import React, { useEffect, useState } from 'react';
import { ConfirmDialog } from './ConfirmDialog';

export const useDirtyDismiss = ({ dirty, busy, onDiscard }: { dirty: boolean; busy: boolean; onDiscard: () => void }) => {
  const [confirming, setConfirming] = useState(false);
  useEffect(() => {
    if (!dirty) return;
    const warn = (event: BeforeUnloadEvent) => { event.preventDefault(); event.returnValue = ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
  return {
    requestClose: () => { if (!busy) { if (dirty) setConfirming(true); else onDiscard(); } },
    discardConfirmation: confirming && <ConfirmDialog title="¿Descartar los cambios sin guardar?" confirmLabel="Descartar" cancelLabel="Seguir editando"
      onClose={() => setConfirming(false)} onConfirm={() => { setConfirming(false); onDiscard(); }}>
      <p>Los cambios de este editor todavía no se guardaron. Puedes seguir editando o descartarlos.</p>
    </ConfirmDialog>
  };
};
